import { Component, OnInit } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { GrupoService } from "../../../../services/grupo.service";
import { ReportesService } from "../../../../services/reportes.service";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: "app-reportes",
  templateUrl: "./reportes.component.html",
  styleUrls: ["./reportes.component.css"],
  providers: [GrupoService, ReportesService]
})
export class ReportesComponent implements OnInit {
  public token: any;
  public identity: any;
  public status: any;
  public report_type = null;
  public message_error: any;
  public message_success: any;
  public filename: string;
  public isReady = false;
  public blobUrl: any = null;

  constructor(
    private _sanitizer: DomSanitizer,
    private _route: ActivatedRoute,
    private _router: Router,
    private _grupoService: GrupoService,
    private _reportesService: ReportesService
  ) {
    this.identity = this._grupoService.getIdentity();
    this.token = this._grupoService.getToken();
  }

  ngOnInit() {}

  changeReport(type) {
    this.isReady = false;
    if (type == "licencia") {
      this.report_type = "licencia";
    } else if (type == "fechas") {
      this.report_type = "fechas";
    } else {
      this.report_type = null;
    }
  }

  generate(type) {
    let obj: any;

    if (type != "licencia" && type != "fechas") {
      this.message_error = "Ingresar un tipo de reporte existente";
      this.status = "error";
      return false;
    }

    if (type == "fechas") {
      var startDate = $("#startDate").val();
      var endDate = $("#endDate").val();
      obj = { startDate, endDate };
    } else if (type == "licencia") {
      var licencia = $("#licencia_funcionamiento").val();

      if (licencia === "") {
        $(".reporte").show();
        this.status = "error";
        this.message_error = "La licencia no puede ser nula o vacia";

        setTimeout(function() {
          $(".reporte")
            .fadeTo(500, 1)
            .slideUp(500, function() {
              $(".reporte").hide();
            });
        }, 3000);
      }
    }

    $(".loading").show();

    if (type == "fechas") {
      this._reportesService.getReportByDates(this.token, obj).subscribe(
        response => {
          $(".loading").hide();
          this.filename =
            "Reporte del " + startDate + " al " + endDate + ".xlsx";
          this.blobUrl = this._sanitizer.bypassSecurityTrustUrl(
            URL.createObjectURL(response)
          );
          this.isReady = true;
        },
        error => {
          $(".loading").hide();

          if (error["status"] == 401) {
            this._router.navigate(["logout/1"]);
          } else if (HttpErrorResponse) {
            if (error.error instanceof Blob) {
              const reader = new FileReader();
              reader.addEventListener("loadend", () => {
                if (typeof reader.result === "string") {
                  $("#reporte").show();
                  const obj = JSON.parse(reader.result);
                  this.message_error = obj.message;
                  this.status = "error";
                } else {
                  this.message_error = "Existe un error en el sistema, intente";
                }
              });
              reader.readAsText(error.error);
              setTimeout(function() {
                $(".reporte")
                  .fadeTo(500, 1)
                  .slideUp(500, function() {
                    $(".reporte").hide();
                  });
              }, 3000);
            }
          }
        }
      );
    } else {
      this._reportesService.getReportByLicencia(this.token, licencia).subscribe(
        response => {
          $(".loading").hide();
          this.filename = "Reporte licencia " + licencia + ".xlsx";
          this.blobUrl = this._sanitizer.bypassSecurityTrustUrl(
            URL.createObjectURL(response)
          );
          this.isReady = true;
        },
        error => {
          $(".loading").hide();

          if (error["status"] == 401) {
            this._router.navigate(["logout/1"]);
          } else if (HttpErrorResponse) {
            if (error.error instanceof Blob) {
              const reader = new FileReader();
              reader.addEventListener("loadend", () => {
                if (typeof reader.result === "string") {
                  $("#reporte").show();
                  const obj = JSON.parse(reader.result);
                  this.message_error = obj.message;
                  this.status = "error";
                } else {
                  this.message_error = "Existe un error en el sistema, intente";
                }
              });
              reader.readAsText(error.error);
              setTimeout(function() {
                $(".reporte")
                  .fadeTo(500, 1)
                  .slideUp(500, function() {
                    $(".reporte").hide();
                  });
              }, 3000);
            }
          }
        }
      );
    }
  }
}
